"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PawPrint, Dog, Heart, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesOverview() {
  const {
    ref: gridRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    id: 1,
    title: "Boarding for Horses and Dogs",
    description: "State-of-the-art stables and secure kennels providing comfortable, safe lodging for your beloved animals.",
    icon: PawPrint
  }, {
    id: 2,
    title: "Training for Horses and Dogs",
    description: "Expert behavior coaching and personalized training programs tailored to each species' unique needs.",
    icon: Dog
  }, {
    id: 3,
    title: "Health Monitoring for Horses and Dogs",
    description: "Comprehensive health checks, nutrition planning, and ongoing wellness support from experienced staff.",
    icon: Heart
  }, {
    id: 4,
    title: "Grooming for Horses and Dogs",
    description: "Professional grooming services ensuring your animals look and feel their best at all times.",
    icon: Sparkles
  }];
  return <section id="services-overview" className="relative py-20 bg-background">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive care tailored to each species, delivered by experienced professionals in a spacious rural facility.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="group relative bg-muted-light-background border border-primary/20 rounded-[20px] shadow-soft hover:shadow-strong transition-all duration-[150ms] ease-out overflow-hidden" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(12px)",
            transitionDelay: isVisible ? `${i * 50}ms` : "0ms"
          }}>
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[150ms]" />
                
                <CardHeader className="relative">
                  <div className="mb-4 inline-flex p-4 bg-primary/10 rounded-[16px] group-hover:animate-[bounce_600ms_ease-in-out]">
                    <Icon className="size-10 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="relative">
                  <p className="text-muted-foreground leading-relaxed mb-6">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}